module.exports = __webpack_public_path__ + "e1bcf77096248a17eef860ca0255e4f5.png";